export default function (doc) {
  if (doc.type) {
    return `/${doc.type}`;
  }

  return '/';
}
